import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import SetPassword from "./pages/SetPassword";
import RegisterIndividual from "./pages/RegisterIndividual";
import RegisterCompany from "./pages/RegisterCompany";
import VerifyEmail from "./pages/VerifyEmail";
import AziendaDashboard from "./pages/AziendaDashboard";
import AdminOrders from "./pages/AdminOrders";
import AdminPayments from "./pages/AdminPayments";
import AdminDashboard from "./pages/AdminDashboard";
import AdminUtenti from "./pages/AdminUtenti";
import AdminCertificates from "./pages/AdminCertificates";
import AdminFeedback from "./pages/AdminFeedback";
import AdminCommissions from "./pages/AdminCommissions";
import PublicVerify from "./pages/PublicVerify";
import PublicCatalog from "./pages/PublicCatalog";
import PublicCourseDetail from "./pages/PublicCourseDetail";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import VerificaAttestato from "./pages/VerificaAttestato";
import AdminContactRequests from "./pages/AdminContactRequests";
import CoursesList from "./pages/CoursesList";
import FormatoreCommissions from "./pages/FormatoreCommissions";
import StudenteDashboard from "./pages/StudenteDashboard";
import StudenteCourseDetail from "./pages/StudenteCourseDetail";
import LessonPlayer from "./pages/LessonPlayer";
import TakeTest from "./pages/TakeTest";
import CourseProgress from "./pages/CourseProgress";
import Profile from "./pages/Profile";
import CourseEditor from "./pages/CourseEditor";
import Cart from "./pages/Cart";
import NotFound from "./pages/NotFound";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/password-dimenticata" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/imposta-password" element={<SetPassword />} />
            <Route path="/registrati" element={<RegisterIndividual />} />
            <Route path="/registrati/azienda" element={<RegisterCompany />} />
            <Route path="/verifica-email" element={<VerifyEmail />} />

            {/* Super Admin */}
            <Route
              path="/admin"
              element={
                <ProtectedRoute roles={["super_admin"]}>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/utenti"
              element={
                <ProtectedRoute roles={["super_admin"]}>
                  <AdminUtenti />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/corsi"
              element={
                <ProtectedRoute roles={["super_admin"]}>
                  <CoursesList scope="admin" />
                </ProtectedRoute>
              }
            />
            {/* Sezione Iscrizioni rimossa: sostituita dal flusso ordini → licenze → assegnazione */}
            <Route path="/admin/iscrizioni" element={<Navigate to="/admin/utenti" replace />} />
            <Route
              path="/admin/certificati"
              element={
                <ProtectedRoute roles={["super_admin"]}>
                  <AdminCertificates />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/feedback"
              element={
                <ProtectedRoute roles={["super_admin"]}>
                  <AdminFeedback />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/richieste"
              element={
                <ProtectedRoute roles={["super_admin"]}>
                  <AdminContactRequests />
                </ProtectedRoute>
              }
            />
            {/* Organizzazioni fuse nella rubrica Utenti */}
            <Route path="/admin/organizations" element={<Navigate to="/admin/utenti" replace />} />
            <Route
              path="/admin/ordini"
              element={
                <ProtectedRoute roles={["super_admin"]}>
                  <AdminOrders />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/pagamenti"
              element={
                <ProtectedRoute roles={["super_admin"]}>
                  <AdminPayments />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/provvigioni"
              element={
                <ProtectedRoute roles={["super_admin"]}>
                  <AdminCommissions />
                </ProtectedRoute>
              }
            />

            {/* Public verification (no auth) */}
            <Route path="/verifica/:code" element={<PublicVerify />} />
            <Route path="/verifica-attestato" element={<VerificaAttestato />} />

            {/* Public catalog (no auth) */}
            <Route path="/corsi" element={<PublicCatalog />} />
            <Route path="/corsi/:id" element={<PublicCourseDetail />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />

            {/* Formatore */}
            <Route
              path="/formatore"
              element={
                <ProtectedRoute roles={["formatore"]}>
                  <CoursesList scope="own" />
                </ProtectedRoute>
              }
            />
            <Route
              path="/formatore/provvigioni"
              element={
                <ProtectedRoute roles={["formatore"]}>
                  <FormatoreCommissions />
                </ProtectedRoute>
              }
            />

            {/* Azienda (referente) */}
            <Route
              path="/azienda"
              element={
                <ProtectedRoute roles={["azienda"]}>
                  <AziendaDashboard />
                </ProtectedRoute>
              }
            />

            {/* Studente */}
            <Route
              path="/studente"
              element={
                <ProtectedRoute roles={["studente"]}>
                  <StudenteDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/studente/corsi/:id"
              element={
                <ProtectedRoute roles={["studente"]}>
                  <StudenteCourseDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/studente/corsi/:id/lezioni/:lesson_id"
              element={
                <ProtectedRoute roles={["studente"]}>
                  <LessonPlayer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/studente/test/:attemptId"
              element={
                <ProtectedRoute roles={["studente"]}>
                  <TakeTest />
                </ProtectedRoute>
              }
            />
            <Route
              path="/studente/test/:attemptId/risultato"
              element={
                <ProtectedRoute roles={["studente"]}>
                  <TakeTest />
                </ProtectedRoute>
              }
            />

            {/* Formatore/Admin progress view */}
            <Route
              path="/corsi/:id/progressi"
              element={
                <ProtectedRoute roles={["super_admin", "formatore"]}>
                  <CourseProgress />
                </ProtectedRoute>
              }
            />

            {/* Shared */}
            <Route
              path="/profilo"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/carrello"
              element={
                <ProtectedRoute roles={["azienda", "studente"]}>
                  <Cart />
                </ProtectedRoute>
              }
            />
            <Route
              path="/corsi/:id/modifica"
              element={
                <ProtectedRoute roles={["super_admin", "formatore"]}>
                  <CourseEditor />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
